import "./index.scss"
import { FiChevronDown } from "react-icons/fi";
import { Link } from "react-router-dom";

interface CNProps {
}

export function CategoryNav(props: CNProps) {
    return (
        <div className="bg-white border-bottom">
            <div className="max-width p-x CategoryNav desktop">
                <div className="CategoryNav-left">
                    <div className="CategoryNav-left-link hover-green">
                        <div className="CategoryNav-left__categories-title">categories <i><FiChevronDown /></i></div>
                        <div className="CategoryNav-left__categories-sub d-none">
                            <span>fish and vegetable</span>
                            <span>fish and vegetable</span>
                            <span>fish and vegetable</span>
                            <span>fish and vegetable</span>
                            <span>fish and vegetable</span>
                            <span>fish and vegetable</span>
                            <span>fish and vegetable</span>
                            <span>fish and vegetable</span>
                        </div>
                    </div>
                    <div className="CategoryNav-left-link hover-green">about us</div>
                    <div className="CategoryNav-left-link hover-green">contact us</div>
                    <div className="CategoryNav-left-link hover-green">
                        <div className="CategoryNav-left__categories-title">pages <i><FiChevronDown /></i></div>
                        <div className="CategoryNav-left__categories-sub d-none">
                            <span>fish and vegetable</span>
                            <span>fish and vegetable</span>
                            <span>fish and vegetable</span>
                            <span>fish and vegetable</span>
                            <span>fish and vegetable</span>
                            <span>fish and vegetable</span>
                            <span>fish and vegetable</span>
                            <span>fish and vegetable</span>
                        </div>
                    </div>
                    <div className="CategoryNav-left-link badge hover-green">offers</div>
                </div>
                <div className="CategoryNav-right">
                    <Link className="CategoryNav-right-link hover-green" to='/privacy-policy'>privacy policy</Link>
                    <Link className="CategoryNav-right-link hover-green" to='/terms-and-condtions'>terms & conditions</Link>
                    {/* .CategoryNav-right-link */}
                </div>
            </div>
        </div>
    )
}